import { render } from "./FullManuscriptUploader.vue?vue&type=template&id=a0f091fe"
import script from "./FullManuscriptUploader.vue?vue&type=script&lang=js"
export * from "./FullManuscriptUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__